// extracted by mini-css-extract-plugin
export default {"alertContainer":"styles_alertContainer__9q1v1","cardClickable":"styles_cardClickable__X1WVO"};